module.exports = function(event) {

	var master = this;
	var runner = {};
	var action, $cntnr, $collection, $open;

/* ==========================================================================
	Get Some Vars
	========================================================================= */

	// .is() over .hasClass() for SVG support :(
	action = $(this).is(".slider-trigger") ? "toggleClass" : false;
	action = !action && $(this).is(".slider-close") ? "removeClass" : action;
	action = !action && $(this).is(".slider-open") ? "addClass" : action;

	$cntnr = $(this).data("slider-group") ? $( $(this).data("slider-group") ) : $(this).closest(".slider-group");

	prevent         = $cntnr.is("[data-no-prevent]") ? false : true;
	stopPropogation = $cntnr.is("[data-do-propogate]") ? false : true;

/* ==========================================================================
	Transition Detection
	========================================================================= */

	var transitionEvent = require("./transition-event")();

/* ==========================================================================
	Runner
	========================================================================= */

	runner.run = function($cntnr, action) {

		var self = this;

/* ======================================================================
	State Checks
	===================================================================== */

		this.isOpen = function() {
			return self.$cntnr.hasClass("open");
		}

		this.shouldClose = function() {
			return self.isOpen() && self.action === "removeClass";
		}

		this.shouldOpen = function() {
			return !self.isOpen() && self.action === "addClass";
		}

		this.shouldToggle = function() {
			return self.action === "toggleClass";
		}

/* ======================================================================
	Find Target
	===================================================================== */

	this.verticalFilterTarget = function($target) {
		return $target.filter(function() {
			var hasHeight = $(this).height() != 0;
			return (!hasHeight && self.shouldOpen()) || (hasHeight && self.shouldClose()) || self.shouldToggle();
		});
	}

	this.horizontalFilterTarget = function($target) {
		return $target.filter(function() {
			var hasWidth = $(this).width() != 0;
			return (!hasWidth && self.shouldOpen()) || (hasWidth && self.shouldClose()) || self.shouldToggle();
		});
	}

	this.findTarget = function($cntnr) {
		var $target = $cntnr.find(".slider-target");

		if (!$cntnr.closest(".slider-target").length) {
			$target = $target.not(".slider-target .slider-target");
		}

		$target = self[self.type + "FilterTarget"]($target);

		return $target;
	}


/* ==========================================================================
	Var Setup
	========================================================================= */

		this.action          = action;
		this.$cntnr          = $cntnr;
		this.prevent         = prevent;
		this.stopPropogation = stopPropogation;

		this.type      = this.$cntnr.data("slide");
		this.$target   = this.findTarget(this.$cntnr);

/* ==========================================================================
	Make a Clone for Size Comparisons
	========================================================================= */

		this.makeClone = function() {
			self.$clone = self.$cntnr.clone();
			self.$clone.css({
				display:    'block',
				position:   'fixed',
				visibility: 'hidden',
			});

			self.$clone.appendTo(self.$cntnr.parent());
			self.$cloneTarget = this.findTarget(self.$clone);
		};

/* ==========================================================================
	Animation Types
	========================================================================= */

		this.vertical = function() {
			// First explicitly set our current height
			self.$target.height(self.$cloneTarget.outerHeight());

			self.$clone.css({
				width: self.$cntnr.width(),
			});

			// Then toggle the class, and set our new height
			self.$clone[self.action]("open");
			var height = self.$cloneTarget.outerHeight();
			self.$target.height(height);
		};

		this.horizontal = function() {
			// First explicitly set our current width
			self.$target.width(self.$cloneTarget.outerWidth());

			self.$clone.css({
				height: self.$cntnr.height(),
			});

			// Then toggle the class, and set our new width
			self.$clone[self.action]("open");
			var width = self.$cloneTarget.outerWidth();
			self.$target.width(width);
		};

/* ==========================================================================
	Callable Funcs
	========================================================================= */

		this.toggle = function() {
			self.$cntnr.toggleClass("open");
		};

		this.open = function() {
			self.$cntnr.remove("open");
		};

		this.close = function() {
			self.$cntnr.remove("open");
		};

/* ==========================================================================
	Utility
	========================================================================= */

		this.cleanup = function() {
			self.$clone.remove();
		};

/* ==========================================================================
	Do the thing.
	========================================================================= */

		if (self.shouldOpen() || self.shouldClose() || self.shouldToggle()) {
			this.prevent && event.preventDefault();
			this.stopPropogation && event.stopPropagation();

			self.$target.one(transitionEvent, function(event) {
				$(this).removeClass("animating").removeAttr("style");
			});

			this.makeClone();
			this.$target.addClass("animating");

			this[this.type].call();

			this.$cntnr[self.action]("open");
			this.$cntnr.trigger(self.action, [this.$target, this.$trigger]);

			this.cleanup();
		}

	};

/* ==========================================================================
	Do the Things
	========================================================================= */


	$cntnr.each(function() {
		$collection = $cntnr.data("slider-collection") ? $( $cntnr.data("slider-collection") ) : false;

		if ($collection) {
			$open = $collection.find(".open");
			($open.length && !$open.is($cntnr)) && runner.run($open, "removeClass");
		}

		runner.run($(this), action);
	});
};
